import React from 'react';
import { Icon } from './Icon.js';
export const IconLabel2Plus = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M13 19L15.5 19L22.5 12L15.5 5L3 5L3 9", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M1 17H9", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M5 13V21", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconLabel2Plus.js.map